module.exports = __webpack_public_path__ + "static/media/blueParrot.a1a1687b.png";